export default {
    API_BASE_URL: "https://trips-unplanned-api.vercel.app/api/comments",
    DB_URL: "postgres://default:XWe6rGLyh2xD@ep-flat-glade-672401-pooler.us-east-1.postgres.vercel-storage.com:5432/verceldb"
}